import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useTheme } from '@/contexts/ThemeContext';
import FrequencyBrowser from '@/components/FrequencyBrowser';
import ThemeToggle from '@/components/ThemeToggle';
import { Button } from '@/components/ui/button';
import { ArrowLeft, LogIn } from 'lucide-react';

const FrequenciesPage = () => {
  const { user } = useAuth();
  const { theme } = useTheme();
  
  return (
    <div className={`min-h-screen ${theme === 'dark' ? 'bg-slate-950' : 'bg-slate-100'}`}>
      {/* Top navigation bar */}
      <div className={`border-b ${theme === 'dark' ? 'border-slate-800 bg-slate-900' : 'border-slate-200 bg-white'}`}>
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <Link to="/">
              <Button variant="ghost" size="sm" className="gap-2">
                <ArrowLeft className="w-4 h-4" />
                Back to Home
              </Button>
            </Link>
            <img 
              src="/veriwatch_dark.png" 
              alt="VeriWatch" 
              className="h-8 w-auto"
              onError={(e) => { e.target.style.display = 'none'; }}
            />
          </div>
          
          <div className="flex items-center gap-3">
            <ThemeToggle />
            {user ? (
              <Link to="/dashboard">
                <Button size="sm" className="bg-teal-600 hover:bg-teal-700">
                  Dashboard
                </Button>
              </Link>
            ) : (
              <Link to="/auth">
                <Button size="sm" variant="outline" className="gap-2">
                  <LogIn className="w-4 h-4" />
                  Login to Submit
                </Button>
              </Link>
            )}
          </div>
        </div>
      </div>
      
      {/* Main content */}
      <FrequencyBrowser />
    </div>
  );
};

export default FrequenciesPage;
